import { createMutation } from 'react-query-kit';

import { sleep } from '@blockworks/platform';

import EditorialConfig from '@/editorial-config';

import { shareApi } from './share';

const uploadImage = async ({
    token,
    image,
    metadata,
}: {
    token: string;
    image: Blob;
    metadata: Record<string, string>;
}) => {
    const uploadRes = await shareApi.post.uploadToken({
        token,
        metadata,
    });

    if (!uploadRes.uploadToken) {
        console.error('Upload Token is missing');
        return;
    }

    const uploadImageRes = await shareApi.post.uploadImage({
        uploadToken: uploadRes.uploadToken,
        image: image,
    });

    if (!uploadImageRes || !uploadImageRes.name) {
        console.error('Upload Image Response is missing');
        return;
    }

    try {
        const shareableUrl = await shareApi.post.createSharePage({
            slug: uploadImageRes.name.replace('.png', ''),
            token,
        });
        if (shareableUrl.success) {
            await sleep(2000); // Give it a chance to propogate
            return { ...uploadImageRes, shareableUrl: EditorialConfig.siteUrl + shareableUrl.path };
        }
    } catch (err) {
        if (err instanceof Error) {
            console.error('Error creating share page', err);
            return;
        }
    }
};

const uploadImageMutation = createMutation({
    mutationFn: uploadImage,
});

const shareMutations = {
    uploadImage: { use: uploadImageMutation },
};

export { shareMutations };
